import { Card, Typography, Loader, LabelValue, Button } from '@design-system/index';
import { useNavigate } from 'react-router-dom';
import '../../DetailsPage.scss';
import { Grid } from '@design-system/components/Grid/Grid';
import { useDetailsBookingsVM } from './useDetailsBookingsVM';
import { APARTMENT_TYPE } from '@utils/enumTranslation';
import { Tabs } from '@components/Tabs/Tabs';
import { BookingsTabs } from './BookingsTabs';

export default function DetailsBookings() {
    const { isLoading, isError, apartment } = useDetailsBookingsVM();
    const navigate = useNavigate();

    if (isLoading) {
        return <Loader className="full-container-loader" />;
    }

    if (isError) {
        return (
            <Typography intrinsic="p" color="secondary">
                Une erreur est survenue lors de la récupération des informations de la fiche logement
            </Typography>
        );
    }

    if (!apartment) {
        return <></>;
    }

    return (
        <div className="details-apartment-container">
            <div className="details-apartment-container-body">
                <Card
                    headerType="very-light"
                    headerTitle={apartment.fullname}
                    headerStaticAction={
                        <Button variant="secondary" onClick={() => navigate(`/members-management/bookings?apartmentId=${apartment.id}`)}>
                            Voir dans la liste des réservations
                        </Button>
                    }
                >
                    <Grid columns={3}>
                        <LabelValue label="Référence" value={apartment.reference} />
                        <LabelValue label="Intitulé du logement" value={apartment.label} />
                        <LabelValue label="Type de logement" value={APARTMENT_TYPE[apartment.type]} />
                    </Grid>
                </Card>

                <Card headerType="none">
                    <Tabs orientation="vertical" tabs={BookingsTabs} className="light" />
                </Card>
            </div>
        </div>
    );
}
